import React from "react";
import Folders from './images/folders.png';
import Card from "./components/Card";
import ChatBot from "./images/chatbot.png";
import Wave from "./images/wave.png";
import Brain from "./images/brain.png";

const APIListing = () => {
  return (
    <div className="p-10 bg-gray-100 min-h-screen flex flex-col justify-center items-center">
      
      {/* Header Section */}
      <div className="text-center mb-10">
        <h1 className="text-3xl font-bold text-gray-900">Explore Our AI Tools</h1>
        <p className="text-gray-600 mt-2 text-lg">
          Discover AI-powered tools designed to enhance productivity and automation.
        </p>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl">
      <Card
          index="1"
          name="Advanced Intelligent AI Portal"
          category="Voice, Real Time Data Storing"
          description="The app's features include seamless connection with Deepgram's voice and transcription APIs. Smart function routing (for example, find_farmer, create_farmer) Agent memory context and guided instructions. Storing data into database utilizing AI and multi-voice In addition, form validation is performed utilizing AI."
          image={Brain}
          links="https://abhishek-verbat-ai-voice.vercel.app/agent"
        />
        <Card
          index="2"
          name="Compare Documents"
          category="Docs"
          description="AI-powered document comparison analyzes two documents to identify differences, similarities, and key insights. It leverages Natural Language Processing (NLP) and Machine Learning (ML) to compare text, detect changes, highlight modifications, and extract meaningful information."
          image={Folders}
          links="https://doc-ai.verbatdemos.com/v2/"
        />
        <Card
          index="3"
          name="Document Chat Bot"
          category="Docs, Chat"
          description="Retrieval-Augmented Generation (RAG) combined with Pinecone enables AI-powered document chat systems that provide accurate, context-aware, and real-time responses by retrieving relevant information from stored documents."
          image={ChatBot}
          links="https://doc-ai.verbatdemos.com/chat-ai-v1/"
        />
        <Card
          index="4"
          name="Talk & Transcribe"
          category="Voice, AI"
          description="AI-powered speech-to-text transcription tool that converts spoken words into text with high accuracy. Uses Deepgram's advanced models for real-time transcription, making it ideal for note-taking, dictation, and content creation."
          image={Wave}
          links="https://doc-ai.verbatdemos.com/audio-to-text/"
        />
      </div>
      
    </div>
  );
};

export default APIListing;
